@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.notificationdata
import com.narbase.letsgo.dto.core.KmmLong

data class RideStatusUpdateDto(
    val request_id: KmmLong,
    val ride_status: String,
    val driver_lat: Double,
    val driver_lng: Double,
    val discounted_price: Double?,
    val discount: Double?
)